module.exports = __webpack_public_path__ + "img/DE01781.f1f29e90.png";